import type { ChannelRow } from '@qlk/shared';

import { StatusBadge } from '../../../ui/index.js';

/**
 * Ô "Nguồn tiền": chip đối tác + phần công ty giữ, ví dụ
 * `CreatorShield` / `Cty 80%`.
 *
 * Gộp hai cột cũ ("Thanh toán qua" và dòng phụ tỷ lệ) thành một ô: câu hỏi là
 * "tiền kênh này đi đường nào, công ty còn bao nhiêu" — một câu, một ô.
 */

/** "Công ty 80% · Network 20%" → "Cty 80%". Nhãn đầy đủ nằm ở `title`. */
export function phanCongTyGiu(splitLabel: string | null): string | null {
  if (splitLabel === null) return null;

  const dau = splitLabel.split('·')[0]?.trim();
  if (dau === undefined || dau === '') return null;

  return dau.replace('Công ty', 'Cty');
}

export function ONguonTien({ kenh }: { kenh: ChannelRow }) {
  const p = kenh.payment;

  if (!p) {
    return <span className="text-chu-phu">Chưa gán đối tác</span>;
  }

  /* `splitLabel` bị bỏ hẳn với người không có `revenue:view` (mục S5) — nó là
     tỷ lệ chia tiền với Network. Tên đối tác thì vẫn hiện: "kênh này đi
     Network nào" là một việc vận hành. */
  const ngan = phanCongTyGiu(p.splitLabel ?? null);

  return (
    <div className="min-w-0">
      <StatusBadge tone={p.kind === 'network' ? 'info' : 'teal'} cham={false}>
        <span className="truncate">{p.partnerName}</span>
      </StatusBadge>
      <p className="mt-0.5 truncate text-phu text-chu-phu" title={p.splitLabel ?? undefined}>
        {p.linkStatus === 'pending'
          ? 'Chờ liên kết AdSense'
          : /* AdSense trực tiếp: không có đối tác nào giữ phần nào. */
            (ngan ?? 'Cty 100%')}
      </p>
    </div>
  );
}
